module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figA03_lead-regression-zones-end-relief.7bb937f5.png";